import {cn} from "@adleritech/web-ui/utils";
import {AdvancedMarker} from "@vis.gl/react-google-maps";
import {FormattedMessage} from "react-intl";
import type {Location} from "@/api/apiClient";
import {usePreservedNavigate} from "@/lib/router";
import {toLatLng} from "../utils/coordinates";
import {Chevron} from "./Chevron";
import styles from "./LocationMarker.module.css";

type LocationMarkerProps = {
    location: Location;
    type: "pickup" | "dropoff";
    isInteractive?: boolean;
    isFlipped?: boolean;
};

export function LocationMarker({
    location,
    type,
    isInteractive = true,
    isFlipped = false,
}: LocationMarkerProps) {
    const navigate = usePreservedNavigate();

    const handleClick = () => {
        navigate(`/taxi/${type}`);
    };

    const messageId = type === "pickup" ? "pickup" : "destination";

    const mapTagClass = cn(styles.mapTag, isFlipped && styles.mapTagFlipped);
    const pointerClass = cn(styles.pointer, isFlipped && styles.pointerFlipped);

    return (
        <AdvancedMarker
            position={toLatLng(location)}
            zIndex={isFlipped ? 0 : 1}
            onClick={isInteractive ? handleClick : undefined}
        >
            <div className={mapTagClass}>
                {isFlipped && <div className={pointerClass} />}
                <div className={styles.eyebrow}>
                    <FormattedMessage id={messageId} />
                </div>
                <div className={styles.content}>
                    <span className={styles.address}>{location.address.split(",")[0]}</span>
                    {isInteractive && <Chevron />}
                </div>
                {!isFlipped && <div className={pointerClass} />}
            </div>
        </AdvancedMarker>
    );
}
